import _pick from 'lodash/pick';
import _functions from 'lodash/functions';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Tabs from '../Common/Tabs';
import Profiles from '../Profiles';
import Stories from '../Stories';
import * as actions from './app.actions';
import { getQueryParams } from '../helpers/location';

/**
 * Application presentation component
 * Represents main part of search page UI
 * Consist from two primary tabs
 */
export class App extends PureComponent {
    static tabs = {
        profiles: {
            header: 'Profiles',
            headerProps: {
                id: 'tabHeaderProfiles',
            },
            content: <Profiles />,
        },
        stories: {
            header: 'Stories',
            headerProps: {
                id: 'tabHeaderStories',
            },
            content: <Stories />,
        },
    }
    static propTypes = {
        /**
         * Currently active tab name
         */
        tab: PropTypes.string.isRequired,
        /**
         * Tab change action: performs switching tabs
         */
        changeTab: PropTypes.func.isRequired,
        /**
         * History change action: changes inner history state
         */
        changeHistory: PropTypes.func.isRequired,
    }

    componentWillMount() {
        this.applyHistory();
    }

    componentDidMount() {
        window.addEventListener('popstate', this.handlePopState);
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
    }

    applyHistory() {
        this.props.changeHistory(getQueryParams());
    }

    handlePopState = () => this.applyHistory()

    render() {
        const { tab, changeTab } = this.props;
        return (
            <Tabs
                tabs={App.tabs}
                tab={tab}
                onChange={changeTab}
            />
        );
    }
}

function mapStateToProps({ tab }) {
    return { tab };
}

/**
 * Application container
 */
export default connect(mapStateToProps, _pick(actions, _functions(actions)))(App);



// WEBPACK FOOTER //
// ./src/js/App/App.jsx